import {SimpleNamingContext} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {PropertyTypeConstructor} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {ICoercionUtil} from '@mintdata/mint-kit/api/types/CoercionUtil';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty, IValue} from '@mintdata/mint-kit/api/types/Value';
import {ABinaryData} from '@mintdata/mint-kit/api/values/ABinaryData';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AByte} from '@mintdata/mint-kit/api/values/AByte';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AIntegerEnum} from '@mintdata/mint-kit/api/values/AIntegerEnum';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameField} from '@mintdata/mint-kit/api/values/frames/FrameField';
import {Frames} from '@mintdata/mint-kit/api/values/frames/Frames';

export abstract class BaseCoercionUtil implements ICoercionUtil
{
    public constructor(public readonly type:Type)
    {
    }

    public toBoolean(from:IValue):ABoolean | ErrorOrEmpty
    {
        return this.toError(from, Type.Boolean);
    }

    public toByte(from:IValue):AByte | ErrorOrEmpty
    {
        return this.toError(from, Type.Byte);
    }

    public toCurrency(from:IValue):ACurrency | ErrorOrEmpty
    {
        return this.toError(from, Type.Currency);
    }

    public toDateTime(from:IValue):ADateTime | ErrorOrEmpty
    {
        return this.toError(from, Type.DateTime);
    }

    public toDate(from:IValue):ADate | ErrorOrEmpty
    {
        return this.toError(from, Type.Date);
    }

    public toTime(from:IValue):ATime | ErrorOrEmpty
    {
        return this.toError(from, Type.Time);
    }

    public toIntegerEnum(from:IValue):AIntegerEnum | ErrorOrEmpty
    {
        return this.toError(from, Type.IntegerEnum);
    }

    public toStringEnum(from:IValue):AStringEnum | ErrorOrEmpty
    {
        return this.toError(from, Type.StringEnum);
    }

    public toInteger(from:IValue):AInteger | ErrorOrEmpty
    {
        return this.toError(from, Type.Integer);
    }

    public toNumber(from:IValue):ANumber | ErrorOrEmpty
    {
        return this.toError(from, Type.Number);
    }

    public toString(from:IValue):AString | ErrorOrEmpty
    {
        return this.toError(from, Type.String);
    }

    public toFrame(from:IValue):IFrame | ErrorOrEmpty
    {
        return Frames.fromFieldsAndData([new FrameField(new SimpleNamingContext().getNextColumnName(), from.getType())], [[from]]);
    }

    public toBinaryData(from:IValue):ABinaryData | ErrorOrEmpty
    {
        return this.toError(from, Type.BinaryData);
    }

    public toCustom(from:IValue, toCtor:PropertyTypeConstructor<any>):any | ErrorOrEmpty
    {
        if( typeof toCtor.coerce === 'function' )
        {
            const coercedValue = toCtor.coerce(from);

            if( coercedValue !== null )
            {
                return coercedValue;
            }
        }

        return new AError(`#CannotCoerce ${from.getType().kind} to ${toCtor.name}`);
    }

    protected toError(from:IValue, toType:Type):AError
    {
        return new AError(`#CannotCoerce ${this.type.kind} to ${toType.kind}`);
    }
}
